import React, { useEffect, useState, useContext } from "react";
import { LanguageContext } from "App";
import AsyncSelect from "react-select/async";
import Swal from "sweetalert2";
import UsersApi from "../Classes/API/UsersApi";
import searchUsersReq from "../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../Classes/Models/Requests/Users/UserTypes";
import MDTypography from "components/MDTypography";

const PatientSelector = ({ setPatient }) => {
  const [patientsSearch, setPatientsSearch] = useState("");
  const [defaultOptions, setDefaultOptions] = useState([]); // Store default patients
  const { translations } = useContext(LanguageContext);

  const [OptionSelect, setOptionSelect] = useState([]);

  useEffect(() => {
    GetPatients().then((res) => {
      setOptionSelect(res);
    });
  }, []);
  // Function to fetch patients
  const GetPatients = async (inputValue = "") => {
    let searchReq = new searchUsersReq();
    let userTypes = new UserTypes();

    searchReq.name = inputValue;
    searchReq.userType = userTypes.Patient;

    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status === "Success") {
      let optionsArr = res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));
      return optionsArr;
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
      return [];
    }
  };

  // Fetch default options on component mount
  useEffect(() => {
    const fetchDefaultOptions = async () => {
      let options = await GetPatients();
      setDefaultOptions(options);
    };
    fetchDefaultOptions();
  }, []);

  return (
    <MDTypography variant="button" fontWeight="regular" color="text" sx={{ width: "100%" }}>
      <AsyncSelect
        isClearable={true}
        sx={{ width: "100%" }}
        defaultOptions={defaultOptions} // Use fetched default options
        loadOptions={GetPatients}
        onInputChange={setPatientsSearch}
        onChange={(e) => setPatient(e ? e.value : "")}
        placeholder={translations.patientselector}
      />
    </MDTypography>
  );
};

export default PatientSelector;
